/* eslint-disable react/jsx-props-no-spreading */
import React, { FC } from 'react';
import {
	ButtonProps as BHButtonProps,
	Button as BHButton,
} from '@buyhatke/react-ui';

import { Link } from '@components/Link';

// import { checkDocument } from '@utils/customLib';

const Button: FC<BHButtonProps> = props => {
	const { link, linkClass } = props;

	if (link) {
		return (
			<Link href={link}>
				<a className={linkClass}>
					<BHButton {...props} />
				</a>
			</Link>
		);
	}

	return <BHButton {...props} />;
};

export { Button };
